export default function Updater(Component) {
  return (props) => {
    return <Component {...props} />;
  };
}
